import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";
import { Container } from "./styles";
import { track } from "../../analytics";

function FloatingWhatsapp({ whatsappPhoneNumber, contactLink }) {
    return (
        <Container href={contactLink ? contactLink : `https://api.whatsapp.com/send?phone=${whatsappPhoneNumber}`} target="_blank" rel="noopener noreferrer" onClick={() => track("contato_whatsapp", { origem: "flutuante" })}>
            <IoLogoWhatsapp height={50} width={30} color="white" fontSize={30} />
        </Container>
    );
}

export default FloatingWhatsapp;